import { useEffect } from 'react';
import {
    Drawer,
    DrawerPanel,
    DrawerBody,
} from '@app/components/ui/drawer/Drawer';
import useUI from '@app/components/ui/state';
import useDrawerDirection from '@app/lib/hooks/use-drawer-direction';

const ProductTruefitDrawer = ({ ctaURL, uiKey, setTriggerRefetch }) => {
    const drawerDirection = useDrawerDirection();
    const { openUIKey, toggleUI } = useUI();
    const isDrawerOpen = openUIKey === uiKey;
    const toggleDrawer = () => {
        toggleUI(isDrawerOpen ? null : uiKey);
    };

    useEffect(() => {
        if (!isDrawerOpen) {
            setTriggerRefetch((prev) => !prev);
        }
    }, [isDrawerOpen, setTriggerRefetch]);

    return (
        <Drawer open={isDrawerOpen} onOpenChange={toggleDrawer}>
            <DrawerPanel inFrom={drawerDirection} variant="truefit">
                <DrawerBody className={''}>
                    {ctaURL && (
                        <iframe
                            src={ctaURL}
                            title="TrueFit Recommendation"
                            style={{ width: '100%', height: '100%' }}
                        ></iframe>
                    )}
                </DrawerBody>
            </DrawerPanel>
        </Drawer>
    );
};

export default ProductTruefitDrawer;
